<template>
  <div id="pageTable" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <div class="flex xs12 sm2">
                <v-select
                        :items="[{
                            text: '기사 이름',
                            value: 'driverName'
                          },
                          {
                            text: '기사 고유번호',
                            value: 'driverId'
                          }]"
                        name="header"
                        v-model="searchFormModel.filter"
                        label="header"
                ></v-select>
              </div>

              <v-text-field
                      flat
                      solo
                      prepend-icon="search"
                      placeholder="Type something"
                      v-model="searchFormModel.filterText"
                      hide-details
                      class="hidden-sm-and-down"
                      @keyup.enter="searchFilter"
              ></v-text-field>

              <v-btn icon @click="searchFilter">
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                      :headers="complex.headers"
                      :items="complex.items"
                      :total-items="totalItems"
                      :rows-per-page-items="[10,25,50]"
                      class="elevation-1"
                      item-key="id"
                      must-sort
                      :pagination.sync="pagination"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-center"><a @click="openDetail(props.item.id)">{{ props.item.id }}</a></td>
                  <td class="text-sm-center">{{ props.item.driverId }}</td>
                  <td class="text-sm-center">{{ props.item.driver.personalInfo.name }}</td>
                  <td class="text-sm-center">{{ props.item.driver.phoneNumber }}</td>
                  <td class="text-sm-center">{{ props.item.carNum }}</td>
                  <td class="text-sm-center">{{ props.item.carModelName }}</td>
                  <td class="text-sm-center">{{ props.item.callOption }}</td>
                  <td class="text-sm-center">{{ props.item.callAcceptTimestamp }}</td>
                  <td class="text-sm-center">{{ props.item.startLocationName }}</td>
                  <td class="text-sm-center">{{ props.item.endLocationName }}</td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import RunningState  from '@/api/runningState';

export default {
  components: {
    VWidget
  },
  data () {
    return {
      autoReload: true,
      pagination: {
        sortBy: 'id',
        descending: true,
        rowsPerPage: 10,
        page: 1
      },
      searchFormModel: {
        filter: 'driverName',
        filterText: ''
      },
      totalItems: 0,
      complex: {
        headers: [
          {
            text: '기사 운행 고유번호',
            value: 'id',
            align: 'center',
            sortable: false
          },
          {
            text: '기사 고유번호',
            value: 'driverId',
            align: 'center',
            sortable: false
          },
          {
            text: '기사 이름',
            value: 'driver.personalInfo.name',
            align: 'center',
            sortable: false
          },
          {
            text: '기사 전화번호',
            value: 'driver.phoneNumber',
            align: 'center',
            sortable: false
          },
          {
            text: '택시번호',
            value: 'carNum',
            align: 'center',
            sortable: false
          },
          {
            text: '택시모델명',
            value: 'carModelName',
            align: 'center',
            sortable: false
          },
          {
            text: '콜 종류',
            value: 'callOption',
            align: 'center',
            sortable: false
          },
          {
            text: '콜 수락시간',
            value: 'callAcceptTimestamp',
            align: 'center',
            sortable: false
          },
          {
            text: '출발지',
            value: 'startLocationName',
            align: 'center',
            sortable: false
          },
          {
            text: '도착지',
            value: 'endLocationName',
            align: 'center',
            sortable: false
          },
        ],
        items: []
      },
    };
  },
  watch: {
    'pagination' () {
      if (this.pagination.totalItems !== 0 && top.getApp.prevPagination != null) {
        if (top.getApp.prevPageName === 'RunningBanBanCallPage') {
          this.pagination = top.getApp.prevPagination;
        }
        top.getApp.prevPagination = null;
        top.getApp.prevPageName = null;
      }
      this.banbanCreated();
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
  },
  methods: {
    banbanCreated () {
      this.loading = true;

      const parameters = {
        method: 'runningBanBanCalls',
        pageNum: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        sortName: this.pagination.sortBy,
        order: this.pagination.descending == true ? 'desc' : 'asc',
        filter: this.searchFormModel.filter,
        filterText: this.searchFormModel.filterText
      };

      this.$store.dispatch('banbanAPI', parameters)
              .then(({ data }) => {
                if (data.statusCode != null && data.statusCode != '200'){
                  throw data.message;
                }
                this.complex.items = data.content;
                this.totalItems = data.totalElements;
                this.loading = false;
                top.getApp.progress.dialog = false;
              })
              .catch((error) => {
                if (top.getApp.commonError == null) {
                  alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                }
                top.getApp.commonError = null;
                top.getApp.progress.dialog = false;
              });
    },
    openDetail (id) {
      top.getApp.addPrevData('RunningBanBanCallPage', this.pagination, this.searchFormModel);
      this.$router.push('/call/runningBanBanCalls/' + id);
    },
    searchFilter () {
      this.banbanCreated();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/call/RunningBanBanCalls.vue